package com.milta.core.localization.translations.en

import com.milta.core.localization.RouteStrings
import com.milta.core.localization.RouteStringsCoreImpl
import com.milta.core.localization.RouteStringsExtraImpl

internal val Route = RouteStrings(
    core = RouteStringsCoreImpl(
    manualDeliveryTitle = "New delivery",
    manualDeliverySubtitle = "Add a delivery to the route",
    recipientNameLabel = "Recipient name",
    addressLabel = "Address",
    phoneNumberLabel = "Phone",
    deliveryTimeLimitLabel = "Time limit",
    optionalSuffix = "(optional)",
    submitButton = "Add and continue",
    saveEditedDeliveryButton = "Save changes",
    deliveryCreated = "Delivery added",
    errorRecipientNameRequired = "Recipient name is required",
    errorRecipientNameTooLong = "Name is too long (150 characters max)",
    errorAddressRequired = "Address is required",
    errorAddressTooLong = "Address is too long (255 characters max)",
    errorPhoneTooLong = "Phone is too long (20 characters max)",
    errorDuplicateDelivery = "This delivery is already in the list (same recipient and address)",
    errorRouteNotFound = "Route not found",
    errorForbidden = "You are not allowed to edit this route",
    errorValidation = "Please check the entered fields",
    errorGeneric = "Something went wrong. Please try again.",
    errorRouteNotInProgress = "This route is no longer in progress. Unable to add a delivery.",
    unknownRecipientLabel = "Unknown",
    driverHomeTitle = "My route",
    driverModeBadge = "Driver mode",
    routeStatusScheduled = "Scheduled",
    routeStatusInProgress = "In progress",
    routeStatusCompleted = "Completed",
    routeStatusPartial = "Partial",
    driversDepartedOne = "started",
    driversDepartedMany = "started",
    driversFinishedOne = "finished",
    driversFinishedMany = "finished",
    stopsDeliveredLabel = "Delivered",
    stopsInProgressLabel = "In progress",
    stopsTodoLabel = "To do",
    stopsFailedLabel = "Failed",
    stopsUntreatedLabel = "Untreated",
    stopsCountLabel = "stops",
    startRouteButton = "Start route",
    noRouteTitle = "No route",
    noRouteSubtitle = "No route is assigned to you right now.",
    noRoutePastSubtitle = "No route was assigned to you for this date.",
    routeInProgressTitle = "Route in progress",
    routeCompletedTitle = "Route completed",
    addStopButton = "Add a stop",
    errorConflict = "The route has already been started or completed.",
    greetingPrefix = "Hello",
    routeOfTheDayLabel = "TODAY'S ROUTE",
    noOtherRouteLabel = "No other route planned",
    routeLabel = "Route",
    importMenuTitle = "Import deliveries",
    importMenuSubtitle = "Combine multiple modes — choose a source",
    importModeScanDocumentTitle = "Scan a document",
    importModeScanDocumentDesc = "Photograph a list or a parcel label",
    importModePdfTitle = "Import a PDF",
    importModePdfDesc = "Delivery notes, scanned file",
    importModeExcelTitle = "Excel / CSV",
    importModeExcelDesc = "Your own format — columns detected automatically",
    importModeManualTitle = "Manual entry",
    importModeManualDesc = "Name, address, phone, time limit",
    photoSourceSheetTitle = "How would you like to add the photo?",
    photoSourceTakePhoto = "Take a photo",
    photoSourceChooseGallery = "Choose from gallery",
    photoSourceChooseFiles = "Choose an image from files",
    createRouteTitle = "Create a route",
    routeCardDetailLabel = "Detail",
    importReviewTitle = "Review imported deliveries",
    importReviewMissingGpsWarning = "GPS coordinates missing",
    importReviewRetryGeocodeAction = "Retry geocoding",
    createRouteEmptyDrivers = "No drivers in your team yet",
    editDeliveriesAction = "Edit",
    moreDeliveriesLabel = "more",
    addDeliveriesAction = "Add deliveries",
    manualEntryAddedConfirmPrefix = "Delivery added:",
    manualEntryMergedConfirmPrefix = "Package added to the existing delivery",
    manualEntryAddedCountLabel = "Deliveries added",
    manualEntryFinishButton = "Finish",
    optimizeRouteButton = "Optimize the route",
    createRouteButtonNoOptimize = "Create the route",
    errorNoEnterprise = "No enterprise linked to your account",
    errorDriverNotFound = "Driver not found",
    errorNoDeliveries = "Add at least one delivery before optimizing the route",
    errorOptimizationUnavailable = "The optimization service is temporarily unavailable.",
    errorGeocodingFailed = "Some delivery addresses could not be located. Edit the address and try again.",
    dispatchTitle = "Optimization",
    optimizedSuccessTitle = "Route optimized!",
    optimizedSuccessSubtitleSuffix = "stops ordered for the shortest route",
    stopsStatLabel = "Stops",
    stopDetailTitlePrefix = "Stop",
    stopStatusCurrentLabel = "In progress",
    stopStatusUpcomingLabel = "Upcoming",
    stopStatusDeliveredLabel = "Delivered",
    stopStatusFailedLabel = "Failed",
    stopRecipientLabel = "Recipient",
    callActionLabel = "Call",
    noPhoneLabel = "Phone not provided",
    packagesCountLabel = "packages",
    navigateButton = "Navigate",
    navigationUnavailableUnverifiedAddress = "Address not verified: navigation unavailable for this stop.",
    deadlineBeforePrefix = "Before",
    deadlinePastSuffix = "overdue",
    validateStopAction = "Validate this stop",
    teamDashboardTitle = "Routes",
    todayDateLabel = "Today",
    statRoutesLabel = "Routes",
    statDeliveriesLabel = "Deliveries",
    statCompletedLabel = "Completed",
    teamSectionTitle = "Team",
    routeStartedAtPrefix = "Started at",
    routeCompletedAtPrefix = "Completed at",
    routeNotStartedLabel = "Not started",
    emptyTeamRoutesTitle = "No route that day",
    emptyTeamRoutesSubtitle = "No driver on the team has a route planned for this date.",
    errorInvalidDate = "Invalid date",
    routeDetailTitle = "Route detail",
    driverEyebrowLabel = "Driver",
    failedDeliveryTag = "Delivery failed",
    driverLoadingCheckTitle = "Loading check",
    loadingCheckInstructionText = "Check that all expected packages are loaded in the vehicle before hitting the road.",
    expectedPackagesLabel = "packages expected for this route",
    confirmLoadCheckboxPrefix = "I have loaded all",
    confirmLoadCheckboxSuffix = "packages expected for this route",
    reportDiscrepancyToggleLabel = "Report a discrepancy",
    discrepancyNotePlaceholder = "E.g.: I loaded 9 packages instead of 11…",
    discrepancyNoteTooLong = "Note too long — 500 characters maximum.",
    undeliveredStopsSectionTitle = "Packages not taken — remove from route",
    removedStopNoticePrefix = "\"",
    removedStopNoticeMiddle = "\" removed from the route — 1 stop fewer",
    remainingStopsSuffix = "remaining",
    confirmAndStartButton = "Confirm and start the route",
    loadingOnBehalfOfLabel = "On behalf of",
    loadingExpectedLabel = "Expected load",
    loadingQuestionTitle = "Did you load all the packages?",
    loadingAllLoadedPrefix = "Yes, all",
    loadingAllLoadedSuffix = "packages are on board",
    loadingIncompleteOption = "Incomplete load",
    loadingIncompleteHint = "I remove the affected stops or justify",
    loadingIncompleteRemoveLabel = "And/or remove the stops not loaded",
    slideToStartLabel = "Slide to start",
    completeRouteButton = "Finish route",
    completeRouteDialogTitle = "Finish the route?",
    completeRouteDialogPendingCountSuffix = "deliveries have not been processed yet",
    completeRouteDialogPendingNote = "They will be marked as failed with the reason given below. You are responsible for these untreated deliveries.",
    completeRouteDialogBody = "This action is final: the route will move to \"Completed\" status and can no longer be modified.",
    completeRouteDialogBodyAllTreated = "All deliveries have been processed. The route will move to \"Completed\" status and can no longer be modified.",
    completeRouteDialogConfirm = "Finish",
    completeRouteDialogReasonLabel = "Reason (optional)",
    completeRouteDialogReasonPlaceholder = "Explain why these deliveries weren't handled…",
    completeRouteDialogNoReasonWarning = "If you don't give a reason, the remaining stops will be recorded as undelivered, at the carrier's fault.",
    routeCompletedMessage = "Route completed.",
    stopStatusUntreatedLabel = "Untreated",
    errorCompleteRouteStatusConflict = "This route cannot be completed in its current state.",
    errorCompleteRoutePendingStopsConflict = "Some deliveries are still pending. Confirm to finish anyway.",
    stopSearchOpenAction = "Search for a stop",
    stopSearchCloseAction = "Close search",
    stopSearchPlaceholder = "Name, address or phone",
    stopSearchClearTextAction = "Clear text",
    stopSearchResultCount = "%1 stops of %2",
    stopSearchResultCountOne = "1 stop of %1",
    stopSearchEmptyTitle = "No matching stop",
    stopSearchEmptyHint = "Check the spelling or search by address or phone.",
    stopSearchClearAction = "Clear search",
    stopPositionLabel = "No. %1",
    ),
    extra = RouteStringsExtraImpl(
    packageCountFieldLabel = "Number of packages",
    reoptimizeSuccessTitle = "Route re-optimised",
    backToRouteButton = "Back to route",
    routeBatchMultiDriverLink = "Split between several drivers",
    routeBatchSelectTitle = "Split the route",
    routeBatchDeliveriesReadyLabel = "deliveries ready to be split",
    routeBatchDriversSectionTitle = "Drivers",
    routeBatchDriversSelectedSuffix = "drivers selected",
    routeBatchOptimizeToggleTitle = "Optimize the itinerary",
    routeBatchOptimizeToggleHelp = "RoutaR splits and orders the stops by distance. Disabled: simple equal split by stop count, no route calculation.",
    routeBatchSubmitButtonPrefix = "Split between",
    routeBatchDriversWord = "drivers",
    routeBatchOptimizationUnavailable = "Optimization service temporarily unavailable. The route wasn't created — check your connection and retry, or turn off \"Optimize the itinerary\" for an immediate simple split.",
    routeBatchPreviewTitle = "Split preview",
    routeBatchPreviewEyebrowMiddle = "deliveries split between",
    routeBatchPreviewEyebrowSuffix = "drivers",
    routeBatchStopsChipSuffix = "stops",
    routeBatchDistanceLabel = "Distance",
    routeBatchDurationLabel = "Estimated duration",
    routeBatchDistanceNotCalculated = "Not calculated",
    routeBatchOptimizeDisabledBanner = "Optimization disabled: equal split by stop count, no distance or stop order calculated.",
    routeBatchReoptimizeButton = "Re-optimize",
    routeBatchDispatchButton = "Confirm and send",
    errorRouteBatchAlreadyDispatched = "This batch has already been sent to drivers — it can no longer be changed.",
    routeBatchDispatchedTitle = "Routes sent!",
    routeBatchDispatchedSubtitleSuffix = "drivers notified at once, each with their own scheduled route.",
    routeBatchStatRoutesLabel = "Routes",
    routeBatchStatDeliveriesLabel = "Deliveries",
    routeBatchStatusLabel = "Status",
    routeBatchStatusDispatchedValue = "Sent",
    routeBatchSentAtLabel = "Sent on",
    routeBatchPerDriverTitle = "Per-driver detail",
    routeBatchDriverScheduledStatus = "Scheduled",
    routeBatchBackToHomeButton = "Back to home",
    errorTooManyDrivers = "You can't select more than 50 drivers at once.",
    errorTooManyDeliveries = "A batch can't exceed 500 deliveries.",
    createRouteFabLabel = "New route",
    createOwnRouteButtonLabel = "Create / Optimize my route",
    createOwnRouteTitle = "Create my route",
    createOwnRouteDeliveriesCountSuffix = "deliveries ready",
    stopStatusEnRouteLabel = "On the way",
    yesterdayDateLabel = "Yesterday",
    periodPastLabel = "Past",
    periodTomorrowLabel = "Tomorrow",
    viewRouteButton = "View route",
    viewButton = "View",
    noRouteTomorrowTitle = "Nothing planned for tomorrow",
    noRouteTomorrowSubtitle = "Plan a route in advance to have it ready first thing tomorrow morning.",
    planRouteButtonLabel = "Plan a route",
    myRoutesTodayTitle = "Your routes today",
    myRoutesTitle = "Your routes",
    weekdayShortNames = listOf("Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"),
    weekdayFullNames = listOf("Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"),
    monthNames = listOf("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"),
    statRoutesTodayLabel = "Routes today",
    statStopsTodayLabel = "Stops today",
    statOnTimeLabel = "On time today",
    statAvgProgressLabel = "Average progress",
    inProgressSectionTitle = "In progress",
    upcomingSectionTitle = "Upcoming",
    doneSectionTitle = "Completed",
    seeAllLabel = "See all",
    continueRouteButton = "Continue route",
    detailsLinkLabel = "Details",
    deliveryProofTitle = "Validate delivery",
    deliveryProofStatusSectionLabel = "Delivery status",
    deliveryProofPhotoSectionLabel = "Proof photo",
    deliveryProofPhotoHint = "Required to validate",
    deliveryProofTakePhotoCta = "Take a photo",
    deliveryProofRetakePhotoCta = "Retake a photo",
    deliveryProofRetakeChipLabel = "Retake",
    deliveryProofCommentSectionLabel = "Comment",
    failureReasonRouteClosedByDriver = "Route closed by the driver: stop undelivered, at the carrier's fault.",
    deliveryProofCommentRequiredSuffix = "required if failed",
    deliveryProofCommentPlaceholderOptional = "Optional — details about the delivery…",
    deliveryProofCommentPlaceholderRequired = "Explain the reason for the failure…",
    deliveryProofCommentRequiredError = "A comment is required when the delivery has failed",
    deliveryProofSubmitButton = "Validate delivery",
    deliveryProofErrorInvalidPhoto = "Photo unreadable or unsupported format. Retake the photo and try again.",
    deliveryProofAlreadyProcessedBanner = "This stop has already been processed and can no longer be modified.",
    proofPhotoViewerDownloadLabel = "Download",
    proofPhotoViewerCloseLabel = "Close",
    proofPhotoDownloadedMessage = "Photo saved to gallery.",
    proofPhotoDownloadErrorMessage = "Couldn't save the photo.",
    deliveryConfirmTitle = "Delivery validated",
    deliveryConfirmSuccessTitle = "Delivery confirmed",
    deliveryConfirmSuccessSubtitle = "The proof has been saved for this stop.",
    deliveryConfirmFailedTitle = "Failure recorded",
    deliveryConfirmFailedSubtitle = "The comment and photo have been sent to the manager.",
    deliveryConfirmRouteCompletedTitle = "Route completed!",
    deliveryConfirmRouteCompletedSubtitle = "All stops have been processed.",
    deliveryConfirmValidatedAtLabel = "Validated on",
    deliveryConfirmNextStopEyebrowPrefix = "Next stop",
    deliveryConfirmGoToNextStopButton = "Go to next stop",
    deliveryConfirmAllDoneMessage = "That was the last stop of the route — remember to close it out.",
    offlineBannerTitle = "Offline",
    offlineBannerRouteSubtitle = "your validations will be sent once the network is back",
    offlineBannerValidateSubtitle = "will be saved locally",
    offlineSyncingBannerTitle = "Syncing in progress",
    offlineSyncingSubtitleSuffix = "deliveries sent",
    offlineRetryBannerTitle = "Sync failed",
    offlineRetryBannerSubtitle = "next attempt on the next network connection",
    offlineSyncSuccessToastSuffix = "deliveries synced successfully",
    offlineQueuedBadgePendingLabel = "Awaiting send",
    offlineQueuedBadgeSyncingLabel = "Sending",
    offlineQueuedBadgeFailedLabel = "Failed — retry planned",
    offlineQueuedBadgeConflictLabel = "Already handled elsewhere",
    offlineDismissConflictAction = "Dismiss",
    offlineValidatedLocallyAtPrefix = "saved locally at",
    offlineAddStopRequiresConnectionSuffix = "(requires a connection)",
    deliveryProofOfflineSubmitButton = "Save (sync later)",
    deliveryProofSavedLocallyTitle = "Saved locally",
    deliveryProofSavedLocallySubtitle = "This delivery will be sent automatically once the connection is restored.",
    routeScheduledBannerTitle = "Route not started yet",
    routeScheduledBannerSubtitle = "Start the route to be able to validate a delivery.",
    geocodeIssueTag = "Address not located",
    regeocodeAction = "Retry geolocation",
    regeocodeSuccessMessage = "Addresses updated",
    dashboardTitle = "Dashboard",
    viewAllAction = "View all",
    deleteRouteDialogTitle = "Delete this route?",
    deleteRouteDialogMessage = "This route will be permanently deleted. This action cannot be undone.",
    errorRouteDeleteConflict = "Deletion unavailable: the route is in progress.",
    errorDriverHasActiveRoute = "Another route is currently in progress. Finish it before starting this one.",
    routeBatchNoStopsTag = "No stops",
    routeBatchNoStopsDialogTitle = "Driver with no stops",
    routeBatchNoStopsDialogMessage = "At least one driver has no stop assigned. They will still receive an empty route unless removed from this batch. Send anyway?",
    routeBatchAddressesToReviewTag = "address(es) to review",
    otherDeliveriesInImportLabel = "Other deliveries in this import",
    proofPhotoUnavailableLabel = "Photo unavailable",
    deliveryProofPhotoOptionalSectionLabel = "Photo (optional)",
    proofWithoutPhotoLabel = "No photo",
    removeStopDialogTitle = "Remove this stop?",
    removeStopDialogMessage = "\"{name}\" ({count} parcels) will be removed from the route. This action cannot be undone.",
    deliveryRemovedMessage = "Delivery removed",
    undoAction = "Undo",
    callLaunchFailed = "Unable to start the call on this device",
    keepDraftsDialogTitleOne = "Keep the delivery?",
    keepDraftsDialogTitleMany = "Keep the {count} deliveries?",
    keepDraftsDialogMessage = "You entered them, but they are not in the list yet.",
    keepDraftsAction = "Keep",
    deliveriesAddedToRouteOne = "1 delivery added to the route",
    deliveriesAddedToRouteMany = "{count} deliveries added to the route",
    driverJoinedTeamMessage = "{name} joined the team",
    ownRouteCreatedNotOptimizedMessage = "Route created in the entered order: the optimization could not be done",
    draftExitTitle = "Leave route creation?",
    draftExitMessageOne = "You added 1 delivery ({packages} parcels).",
    draftExitMessageMany = "You added {count} deliveries ({packages} parcels).",
    draftKeepAction = "Keep for later",
    draftDeleteDeliveriesAction = "Delete the deliveries",
    draftContinueAction = "Continue creating",
    draftSavedMessage = "Draft saved",
    draftCardTitle = "Route being created",
    draftForDate = "for {date}",
    draftResumeAction = "Resume",
    draftDeleteDialogTitle = "Delete the draft?",
    draftDeleteDialogMessageOne = "The delivery ({packages} parcels) already entered will be deleted. This action cannot be undone.",
    draftDeleteDialogMessageMany = "The {count} deliveries ({packages} parcels) already entered will be deleted. This action cannot be undone.",
    draftResumeImportTitle = "Resume the route in progress",
    draftImportAddsHint = "Imported deliveries will be added to this draft:",
    stopDeliveredAtPrefix = "Delivered at",
    stopFailedAtPrefix = "Failed at",
    stopOnTimeLabel = "On time",
    stopLateByPrefix = "Late by",
    stopTimeLabel = "Time",
    stopAfterStartSuffix = "after the start",
    stopAfterPreviousSuffix = "after the previous stop",
    stopDriverCommentLabel = "Driver's comment",
    stopPackagesLabel = "Packages",
    durationHoursUnit = "h",
    durationMinutesUnit = "min",
    ),
)
